"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinanceService = void 0;
const APIService_1 = require("./APIService");
const calculate = (params) => APIService_1.MyLeaseAPIService.get(`/rateMotoup`, {
    params: params,
});
exports.FinanceService = {
    calculate,
};
//# sourceMappingURL=FinanceService.js.map